module.exports = {
  menu : {
       AccountCenter:'Nutzerkonto',//德国 endamoto.com
 
    EmployeeManagement:'Benutzerverwaltung',     //德国 endamoto.com
    EmailAddress:'E-Mail',
    Password:'Kennwort',
    Login:'Login',
    ForgotPassword:'Forgot Password',
    UserName:'Benutzername',
    Distributor:'Handelspartner',
    Role:'Funktion',
    ChangePassword:'Kennwort ändern',
    AddAccount:'Add Account',
    Edit:'Bearbeiten',
    Delete:'Löschen',
    DeleteAccount:'Delete account',
    DelAc:'After deleting the account, the member will no longer be able to continue using it. Are you sure to delete it?',
    FrameNumber:'Fahrgestellnummer',
    EngineNumber:' Motornummer',
    State:'Status',
    StorageDate:'Storage date',
    SaleDate:'Verkaufsdatum',
    Operation:'Aktion',
    Register:'Register',
    Details:'Details',
    Export:'Export',
    Download:'Download',
    VehicleName:'Vehicle name',
    Colour:'Colour',
    DeliveryDate:'Delivery Date',
    CustomerInformation:'Customer Information',
    CustomerType:'Customer type',
    licensePlateNumber:'License plate number',
    contactNumber:'Contact number',
    EmailAddress:'E-Mail',
    Address:'Address',
    PictureMaterials:'Picture materials',
    Save:'Save',
    Cancel:'Cancel',
    Modify:'Modify',
    PurchasementOfAccessoires:'Purchasement of accessoires',
    ApplicableModels:'Zugeordnete Modelle',
    All:'Alle',
    NO:'NO.',
    AddToCart:'Add',
    SoldOut:'Nicht lagernd',
    Attachment:'Attachment',
    VehicleModel:'Modell',
    MinimumPurchaseQuantity:'MOQ',
    UnitUsage:'Unit usage',
    Alternative:'Alternative',
    ShoppingCart:'Shopping Cart',
    Code:'Teilenummer',
    Product:'Teilebezeichnung',
    UnitPrice:'Preis',
    Quantity:'Menge',
    Quantitya:'Betrag',
    SubTotal:'Gesamtsumme',
    InvalidProduct:'Invalid product',
    ClearInvalidProducts:'Clear invalid products',
    PaymentMethod:'Abrechnungsart',
    FreightMode:'Shipping type',
    PriceTerms:'Price terms',
    TransferAccounts:'Überweisung',
    AccountPayment:'Account payment',
    Remarks:'Bemerkung',
    Tips:'Tips',
    CheckoutSuccess:'Checkout success',
    DeliveryAddress:'Delivery address',
    Country:'Land',
    Addressee:'Addressee',
    OrderNumber:'Bestellnummer',
    Currency:'Währung',
    PurchaseAmount:'Einkaufsbetrag',
    DeliveryProgress:'Lieferstatus',
    Paymentmethod:'Abrechnungsart',
    SettlementInformation:'Abrechnungsinformationen',
    PaymentInformation:'Zahlungsinformationen',
    SettlementStatus:'Abrechnungsstatus',
    FeeTotal:'Gesamt',
    OrderTime:'Bestellzeit',
    PendingReview:'Zur Prüfung',
    Underreview:'in Prüfung',
    PendingShipment:'Ausstehende Lieferung',
    UnderDelivery:'In Lieferung',
    Completed:'Abgeschlossen',
    ContractNumber:'Bestellnummer',
    PriceTerms:'Price terms',
    ProductDetails:'Product details',
    AddTo:'Add',
    PartCode:'Teilenummer',
    PartName:'Bezeichnung',
    OrderAmount:'Order amount',
    AddParts:'Add parts',
    DeliveryDetails:'Delivery details',
    ClaimOrder:'Claim Order',
    ClaimNumber:'Antragsnummer',
    Vehicle:'Fahrzeug',
    ClaimType:'Garantieart',
    ClaimAmount:'Betrag',
    ApplicationTime:'Eingereicht am',
    ClaimRecord:'Claim record',
    OperationRecord:'Operation record',
    Amount:'Betrag',
    Operator:'Operator',
    OperationContent:'Operation content',
    TransactionSerialNumber:'Transaktionsnr.',
    TransactionOrderNumber:'Auftragsnummer',
    TransactionType:'Transaktionsart',
    IncomeAndExpenditureTypes:'Buchungsart',
    AmountChanges:'Änderungsbetrag',
    Time:'Zeit',
    DocumentCenter:'Document Center',
    ScopeOfApplication:'Anwendungsbereich',
    Title:'Name',
    ReleaseTime:'Veröffentlicht',
    Preview:'Vorschau',
    Bulletin:'Bulletin',
    Type:'Type',
    Receive:'Receive',
    LaborHourList:'Labor hour list',
    ApplyForClaim:'Garantieantrag erstellen',
    ProductName:'Modellname',
    WarrantyPeriod:'Warranty period',
    Customer:'Kunde',
    Dealer:'Händler',
    ClaimInformation:'Schadensinformationen',
    EventName:'Event Name',
    Mileage:'Mileage',
    ProblemDescription:'Problem description',
    Analysis:'Analysis',
    Solution:'Solution',
    ClaimDetails:'Claim details',
    RepairType:'Repair type',
    ClaimForLaborHour:'Claim for labor hour',
    StandardLaborCost:'Standard labor cost',
    LaborHours:'labor hours',
    LaborCost:'Labor cost',
    SupportClaims:'Support claims',
    LobarHourCode:'Lobar hour code',
    CHDescriptionOfLaborHours:'CH description of labor hours',
    ENDescriptionOfLaborHours:'EN description of labor hours',
    StandardLaborHours:'Standard labor hours',
    InUse:'in use',
    Deactivated:'deactivated',
    // LogOff:'Log off',
     LogOff:'Abmelden',     //德国 endamoto.com
    Income:'Income',
    ExpectedShippingdate:'Voraussichtliches Lieferdatum',
    CustomerOrderNo:'Referenz Bestellnummer',
    Kind:'Produkt',
    Remarksaa:'Reasons for refusal',
    Rejected:'Abgelehnt',
    Cancelled:'Storniert',
    ExportOrder:'Bestellung exportieren',
    ExportDetails:'Alles exportieren',
    Expense:'Expense',
    Onlyunread:'Nur ungelesene',
    user:'Benutzer',
    Confirm:'Confirm',
    Inputthepassword:'Input the password',
    Basicinformation:'Informationen',
    search:'Suche',
    Bykeywords:'Stichwortsuche',
    Startdata:'Start data',
    Enddata:'End data',
    to:'to',
    EntertheVIN:'Enter the VIN',
    Add:'Add',
    SUCESS:'SUCESS',
    unit:'Qty/unit',
    Effectivedate:'Effective date',
    Add:'Add',
    Bymodel:'Nach Modell',
    ByVIN:'Nach Fahrgestellnumer',
    Claim:'Antragsnummer',
    Bypart:'Nach Teilenummer',
    Countrya:'Land',
    Shippingtype:'Shipping type',
    Expected:'Voraussichtliches Lieferdatum',
    Enter:'Enter...',
    Submit:'Abschicken',
    Uploadorder:'Upload order',
    OrderNo:'Antragsnummer',
    Country:'Land',
    Reapply:'Antrag erneuern.',
    ItemNo:'Item No.',
    Accountdeduction:'Account deduction',
    Continueordering:'Continue ordering',
    Orderdetails:'Order details',
    Soldout:'Nicht lagernd',
    Total:'Total',
    items:'items',
    uesr:'uesr',
    Edit:'Edit',
    item:'items',
    Import:'Import',
    Pleaseenter:'Please enter your username',
    Pleaseentera:'Please enter your password',
    CustomerName:'Customer name',
    MOQ:'MOQ',
    PartsImportTemplate:'Parts import template',
    SelectFile:'Select File',
    ShipmentInformation :'Shipment information',
    ShipmentNo:'Shipment No.',
    Qty:'Qty',
    ShipmentDate:'Shipment date',
    NoVehiclePartsInformationFound:'No vehicle parts information found',
    Novehiclemodelinformation :'No vehicle model information was found, and claims for this vehicle are not supported',
    Pleaseentertheframe:'Please enter the frame',
    Reset:'Zurücksetzen',
    BulkRegistration:'Mehrfach-Registrierung',
    Importtemplate:'Import template',
    Applicationtime:'Eingereicht am',
    Claimedpart:'Claimed part',
    Uploadfiles:'Hochladen',
    Note10M:'Note: Multiple files can be uploaded, and files in pdf, doc, and docx formats are supported, and the size of a single file cannot exceed 10M',
    Submitsuopei:'Abschicken',
    Cancelsuopei:'Cancel',
    AfterSalesAccountCurrency:'After-sales Account Currency',
    Success:'Success',
    Continue:'Continue',
    Viewtheorder:'View the order',
    Unread:'nicht bearbeitet',
    Approved:'Genehmigt',
    Rejected2:'Abgelehnt',
    Saletime:'Verkaufsdatum',
    Timecaozuo:'Time',
    RegistrationDate:'Registrierungsdatum',
    Unregistered:'Unregistered',
    Registered:'Registered',
    Mileage2:'Mileage(km)',
    FrameNo:'Fahrzeug',
    Failurecategory:'Failure category',
    Underreview11:'in Prüfung',
    Underreview2:'in Prüfung',
    Underreview3:'in Prüfung',
    Underreview4:'in Prüfung',
    Partcategory:'Part category',
    Country1:'Land',
    Reasons:'Reasons for the dismissal',
    Vehicleorder:'Fahrzeugbestellung',
    Partsorder:'Ersatzteilbestellung',
    Parts:'Ersatzteile',
    Vehicle:'Fahrzeuge',



     zcmxcx:'Modell',
    zcmxyhxm:'Kundenname',
    zcmxlsh:'Händler',
    zcmxzbdqsj:'Ablaufdatum der Garantie',
    zcmxyczbqx:'Verlängerte Garantiezeit',
    
    zckckccz:'In Bestand',
    zckckcjz:'Wenig Bestand',
    zckczwkc:'Kein Bestand',
    zckccx:'Modell',
    zckcyc:'Farbe',
    zckcdqkc:'Aktueller Bestand',
    zckckcxx:'Mindestlagerbestand',
    zckczt:'Status',
    zckccz:'Aktion',
    zckcyjsz:'Warnungseinstellungen',

    wbdtj:'Wartungsauftrag hinzufügen',
    wbddh:'Wartungsauftragsnummer',
    wbdlc:'Fahrzeugkilometerstand',
    wbdlss:'Servicehändler',
    wbdsj:'Servicedatum',
    wbdyfw:'Gewartet',
     wbdylxr:'Kontaktperson',
    wbdylxfs:'Kontaktinformation',
    wbdyfwxm:'Servicepunkte',
    wbdymx:'Details',
    wbdysypj:'Verwendete Teile',
    cldasclss:'Verkaufshändler',
    
    cgwdpjdh:'Teilebestellnummer',
    cgwdxdrq:'Bestelldatum',
    cgwdlx:'Typ',
    cgwdpjbm:'Teilenummer',
    cgwdpjmc:'Bezeichnung',
    cgwddgsl:'Bestellmenge',
    cgwdyfh:'Gelieferte Menge',
    cgwdwd:'Lieferrückstand',
    
    lssjxsmc:'Händlername',
    lssyx:'E-Mail',
    lsszt:'Status',
    lsserp:'ERP-Konto-Verknüpfung',
     
    fbwdwjlx:'Dateityp',
    fbwdsc:'Hochladen',
    fbwfbr:'Veröffentlicher',
    xspjfl:'Kategorie',
    xspjsscx:'Zugehöriges Modell',
    xspjfy:'übersetzen',
    xspjxsj:'Verkaufspreis',
    xspjghgs:'Arbeitskosten für Austausch',
    xspjwxgs:'Arbeitskosten für Reparatur',
    xscxjg:'Währung',

    zhglbm:'Kontocode',
   zhgllx:'Kontotyp',
   zhglyem:'Kontostand',
   zhglls:'Transaktionsdetails',

   fhdfhsj:'Versanddatum',
   fhddh:'Lieferscheinnummer',
   fhdglpj:'Zugehörige Teilebestellung',
   fhdfhsl:'Gelieferte Menge',
    shtgs:'Anzahl der genehmigten Prüfungen',
   sqsl:'Anzahl der Anträge',
   sqyb:'Antrag auf Verlängerung der Garantie',
   zsddlx:'Bestelltyp',
   sousuo:'Suchen',
   cbjg:'Kostenpreis',
   erpzd:'Auftrag erstellen',
   zwshj:'Keine Daten verfügbar',
   clmxl:'Fahrzeugdetails',
   clstme:'Behandlungszeit',
   dqzbsj:'Aktuelle Garantiezeit',
   ycnx:'Verlängerung der Laufzeit',
   ychdqsj:'Verlängerung der Fälligkeitsdauer',
    yczbpoz:'Verlängerung des Garantiebelegs',
    tgl:'Durch',
    jul:'Ablehnung',
    pfzl:'in Bearbeitung',
    ypfl:'bereits erstattet',
    dkhqrl:' Antrag wurde abgelehnt, warten auf korrektur.',
    khjc:'Einzelhändler',
    chejiahao:'Fahrgestellnummer',
    dailipei:'in Bearbeitung',
    yilipei:'erstattet',
    suopeishukl:'reklamiert',
    yipeifusl:'erstattet',
    dipeifusl:'wird erstattet',
    xiaoshoudh:'Verkaufsordnungsnr',
    quxiaolip:'storniert',
    zhgengchefahg:'Gesamtbetriebssendung',
    peijianfh:'Zubehör versandt',
    daizhid:'Zubereitungsliste',
    tongzhiduix:'Betroffene Personen',
    quanbulss:'Alle Händler',
    zhidingreny:'Benenneter Person',
    mingxc:'Name',
    congnir:'Inhalt',
    fabutongg:'Mitteilung veröffentlichen',
    xiuggtongg:'Änderungserklärung',
   weibaojil:'Wartungsprotokoll',
    weibaoshijian:'Wartungszeit',
  shengchengpeiqdan:'Erstellen Sie eine Bestellung für Zubehör.',
  chuangjianxiaosd:'Verkaufsausgabe erstellen',
  peijianmingxi:'Zubehör-Details',
  bencipeifus:'Die Höhe der Entschädigung',
  peijianzongs:'Gesamtzahl der Zubehörteile',
  kehugongsi:'Kundenunternehmen',
  fahuod:'Lieferschein',
  changchuanvin:'Laden Sie die Fahrgestellnummer hoch',
  xiazaimuban:'Muster herunterladen',
  daifashul:'Verbleibende Stückzahl',
  bencufahuo:'Diese Versandcharge',
  fahuozongshu:'Gesamtzahl der Versandvolumen',
  chekuan:'Fahrzeugmodell',
  shigonglex:'Baustil',
  weix:'Wartung',
  genghuan:'Wechseln',
  peijianjine:'Zubehörpreis',
  yitonggshul:'Bereits bestätigt',
  yipeifushul:'erstattet',
  shenhezhuangt:'Prüfstatus',
  peijianzioee:'Gesamtbetrag der Zubehörteile',
  gongshifzonge:'Gesamtbetrag der Arbeitszeitkosten',
  xianggongclp:'Führen Sie eine Schadensersatzantrag bei der Fabrik ein.',
  hezuozong:'In der Zusammenarbeit',
  yizhjongzh:'Abgebrochen',
  lingshousquanc:'Vollständige Bezeichnung des Einzelhändlers',
  hezuozhuangt:'Zusammenarbeitszustand',
  wenjianminame:'Dateiname',
   wenjian:'Dokument',
   fabuwendang:'Transaktionsdetails',
   bianjiwendan:'Bearbeiten',
   tianjiachexing:'Modell hinzufügen',
   caigoujiage:'Einkaufspreis',
   daijishushenhe:'Wartet auf technische Prüfung',
   erlunpej:'Motorrad-Ersatzteile',
   silunpej:'ATV-Ersatzteile',
   erlunzhengc:'Motorrad',
   silunzhengc:'ATV',
   erlunpejdd:'Motorrad-Ersatzteile',
   silunpejdd:'ATV-Ersatzteile',
   erlunzhengcdd:'Motorrad',
   silunzhengcdd:'ATV',
   gongchangsuopdh:'Fabrik-Klage-Nummer',
   zheshijiesuanjine:'Abrechnungsbetrag',
   zhejsijiesuan:'Abrechnung',
   yijiesuanjine:'Abgerechnete Summe',
   daijinsuanjin:'offener Betrag',
   yuetiaozheng:'Saldoanpassung',
   zengjia:'Erhöhen',
   jiankou:'Reduzierung',
   fahuozhangt:'Versandstatus', 
   weiwancheng:'Unvollendet',
   yiwancehng:'Abgeschlossen',
   buxianzhi:'Ohne Einschränkung',
   yishenql:'Angebotsbereit',
   
    queddshanchuxuan:'Bestimmen Sie, welche ausgewählten Zubehörteile gelöscht werden sollen.?',
   plshanc:'Löschen',
     zhoubianq:'Zubehör',
      kuaijiedenglul:'Registrierung',
        tijiaojhishushene:'Technische Prüfung einreichen',
        bohui:'Ablehnung',
         jishubanpdduan:'Technische Beurteilung',
         chepaihao:"Kennzeichen",
           baoyangxinxx:"Daten beobachten.",
    baoyang:'Maintenance',
qingshangchaunss:'Please upload the driving license, mileage chart pictures, and pictures of the faulty parts (these are required for repair).', 
chushenjuj:'Vorverhandlung abgelehnt ',
shucujujyy:'Bitte geben Sie den Grund für die Ablehnung ein',   
jishupand:'Technische Entscheidung',
suopk:'Unterstützen Sie die Behauptung?',
zhic:'Ja ja',
nozhic:'Oder',
dadijishupd:'Ein technisches urteil',
tyReapply:'einverstanden',
yueikou:'Gutschrift aus dem Saldo',
xiaddanzhoukbil:'Rabattquote bei Bestellung',
shezhi:'Einrichtung',
yefy:'Saldo',
dczdddk:'Maximaler Rabatt pro Bestellung',
zpnmji:'Insgesamt',
lingshousjianc:'Einzelhändler',
zhuanggjine:'Überweisbetrag',
fapiao:'Invoice',
xglshousshang:'Händler ändern',
xiugailintishi:'Nach der Änderung des Händlers wird die Zuordnung des Fahrzeugprofils aktualisiert.',
xuanzelingshouss:'Händler auswählen',
dayinbiaoq:'Etiketten drucken',
zanwuquanx:'Keine Berechtigung vorhanden',
beihuozhong:'Vorbereitung',
tianjiacheliang:'Fahrzeug hinzufügen',
piliangtianjial:'In Batch hinzufügen',
dangqzhibdaoqihijian:'Ablaufdatum der Garantie',
yanchangqixian:'Verlängerungsfrist',
yinian:'1 Jahr',
liangnian:'2 Jahre',
sannian:'3 Jahre',
sinian:'4 Jahre',
wunian:'5 Jahre',
cheliangzongsshu:'Gesamtzahl',
huruduochejiahaotihsi:'Geben Sie mehrere Fahrgestellnummern mit einem Komma abgetrennt ein',
dantaiyongl:'Einzelverbrauch pro Gerät',
shiwu:'Originalartikel',
xunijine:'virtuelle Summe',
caozuochengong:'Vorgang erfolgreich',
peifufanghui:'Entschädigungsform',
fanhui:'Zurück',
quxiaofahuoo:'Versand abbrechen',
zhekoudanjia:'Rabattpreis',
zhekoujine:'Rabattbetrag',
mubantishi:'Wartung von Vorlagen für Transportkosten, Umschlagkosten, Zertifikatkosten usw. Die Vorlagen definieren lediglich die Kostenstandards; Händler sollten diese in der [Händlerverwaltung] im Massenmodus festlegen.',
addfeiyongmb:'Muster für Neubaukosten',
mubanmingcheng:'Template Name',
yewylixinbg:'Geschäftstyp',
zhesyunshu:'Versandkosten',
zheshibanyun:'Bearbeitungsgebühr',
zheshizhengshu:'Zertifikatsgebühr',
shuoming:'Hinweis',
zheshitishia:'Die Vorlagenbezeichnungen unterstützen mehrsprachige Eingabe, wobei das System automatisch die entsprechende Sprache anzeigt, basierend auf der Sprache des Benutzers.',
chuangjainmban:'Muster erstellen',
feiyongmingx:'Kostenübersicht',
zhesqiy:'Aktivieren',
zhesty:'Deaktivieren',
feiyongshezhi:'Kostenstruktur',
weipeuizhiu:'Nicht konfiguriert',
erlunfuzeren:'Zweirunde Verantwortlicher',
silunfuzeren:'Vier-Fahrzeug-Verantwortlicher',
shouhoufuzeren:'Vertriebs- und Kundendienstleiter',
yiyzjiangxiaos:'Händler ausgewählt',
szldtopshuoming:'Konfigurieren Sie für den ausgewählten Händler Kostenvorlagen für verschiedene Geschäftstypen; nach Speicherung werden die ursprüngliche Konfiguration überschrieben.',
erluncfeiyu:'Kostenstruktur für Zweiräder',
siluncfeiypz:'Kostenstruktur für Fünf-Rad-Fahrzeuge',
feiyongmuy:'Kostenvorlage',
mubancank:'Kostenübersicht für Vorlagen (Referenz)',
feiyonglerx:'Kostenart',
pzldbotshuom:'Nach dem Speichern wird die Bestellung des ausgewählten Händlers automatisch in der ERP-Systeme mit der neuen Kostenkonfiguration verknüpft; bereits erzeugte Bestellungen bleiben unverändert.',
 erlunc:'Fahrrad',
silunc:'Fahrzeug mit vier Rädern',
zhuangxjindu:'Verpackungsfortschritt',
},
}
